import { Component } from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import _ from 'lodash';

import { formatDate } from '../utils/dates';
import { isProductInactive } from '../utils/utils';

import thumbPlaceholderImg from '../assets/thumb_placeholder.png';
import wideThumbPlaceholderImg from '../assets/widethumb_placeholder.png';

var css = {
    packId: '',
    packDragHandle: '',
    packThumb: '',
    packButtons: '',
    row: {
        width: '',
        height: '',
    },
};

const now = Date.now();

const InactiveDisclaimer = ({ activeToDate, activeFromDate }) => {
    const expiringOn = new Date(activeToDate);
    const inactiveUntil = new Date(activeFromDate);

    return (
        <div className="inactiveDisclaimer">
            {now > expiringOn.getTime() ? (
                <>
                    Expired on{' '}
                    <time dateTime={activeToDate}>
                        {formatDate(expiringOn)}
                    </time>
                </>
            ) : (
                <>
                    Inactive until{' '}
                    <time dateTime={activeFromDate}>
                        {formatDate(inactiveUntil)}
                    </time>
                </>
            )}
        </div>
    );
};

class DraggablePacks extends Component {
    onBeforeDragStart = () => {
        css.packThumb = window.getComputedStyle(this.packThumb).width;
        css.packId = window.getComputedStyle(this.packId).width;
        css.packButtons = window.getComputedStyle(this.packButtons).width;
        css.packDragHandle = window.getComputedStyle(this.packDragHandle).width;
        css.row.width = window.getComputedStyle(this.rowElement).width;
        css.row.height = window.getComputedStyle(this.rowElement).height;
    };

    getTdStyle = (isDragging, name) => ({
        width: isDragging && css[name],
        backgroundColor: isDragging && '#EFF8FB',
    });

    render() {
        const props = this.props;
        const { onDragEnd, items } = props;

        return (
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable
                    droppableId="droppable-packs-horizontal"
                    direction="horizontal"
                >
                    {(provided) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                overflowX: 'auto',
                                width: '100%',
                                gap: '20px',
                                paddingTop: 20,
                                paddingBottom: 20,
                            }}
                        >
                            {items.map((item, index) => {
                                const isInactive = isProductInactive(item);
                                const thumb = _.find(item.medias, (m) => {
                                    return m.type === props.thumbType;
                                });

                                return (
                                    <Draggable
                                        key={`pack_draggable_${item.packId}`}
                                        draggableId={item.packId}
                                        index={index}
                                    >
                                        {(dragProvided) => (
                                            <div
                                                className={[
                                                    'pack',
                                                    isInactive
                                                        ? 'inactive'
                                                        : '',
                                                ]
                                                    .join(' ')
                                                    .trim()}
                                                style={{
                                                    userSelect: 'none',
                                                    ...(dragProvided
                                                        .draggableProps.style ??
                                                        {}),
                                                }}
                                                ref={dragProvided.innerRef}
                                                {...dragProvided.draggableProps}
                                                {...dragProvided.dragHandleProps}
                                            >
                                                <div
                                                    className="deletable"
                                                    style={{
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href={`/pack/${item.packId}`}
                                                    >
                                                        <img
                                                            src={
                                                                thumb
                                                                    ? thumb.url.replace(
                                                                          '{0}',
                                                                          '@1x',
                                                                      )
                                                                    : props.thumbType ===
                                                                        'thumbnail'
                                                                      ? thumbPlaceholderImg
                                                                      : wideThumbPlaceholderImg
                                                            }
                                                            style={{
                                                                height: 200,
                                                                width: 200,
                                                                objectFit:
                                                                    'cover',
                                                            }}
                                                            alt={
                                                                'id:' +
                                                                item.packId
                                                            }
                                                        />
                                                        <div className="wrap">
                                                            {item.packId}
                                                        </div>
                                                    </a>
                                                    {isInactive && (
                                                        <InactiveDisclaimer
                                                            activeToDate={
                                                                item.activeToDate
                                                            }
                                                            activeFromDate={
                                                                item.activeFromDate
                                                            }
                                                        />
                                                    )}
                                                    {props.onDelete && (
                                                        <button
                                                            className="deleteIcon"
                                                            onClick={(e) => {
                                                                props.onDelete(
                                                                    e,
                                                                    item,
                                                                );
                                                            }}
                                                        ></button>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                );
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }
}

export default DraggablePacks;
